var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"businesses-page d-flex flex-column justify-content-between"},[_c('div',[_c('BusinessesHeader'),_c('BusinessesBanner'),_c('BusinessesList')],1),_c('PageFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }